import React from 'react'
import { useIntl } from 'react-intl'
import { ProgressBarMedium, Text } from 'mailup-web-components'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import {
  RCS_QUEUING_ERROR,
  RCS_QUEUING_RUNNING,
  RCS_SCHEDULED_READY,
  RCS_SENDING_ERROR,
  RCS_SENDING_FAILED,
  RCS_SENDING_NO_CREDIT,
  RCS_SENDING_READY,
  RCS_SENDING_RUNNING,
  RCS_SENDING_STOPPED,
  RCS_SENDING_STOPPING
} from 'Api/beRcsSend'

const ProgressBar = ({ progressPerc, state, progress, total }) => {
  const intl = useIntl()

  const setVariantProgresBar = val => {
    switch (val) {
      case RCS_QUEUING_RUNNING:
      case RCS_SENDING_READY:
        return 'zero'
      case RCS_QUEUING_ERROR:
      case RCS_SENDING_FAILED:
        return 'error'
      case RCS_SENDING_RUNNING:
      case RCS_SCHEDULED_READY:
        return 'default'
      case RCS_SENDING_ERROR:
      case RCS_SENDING_NO_CREDIT:
      case RCS_SENDING_STOPPING:
      case RCS_SENDING_STOPPED:
        return 'warning'
    }
  }

  return (
    <>
      <StyledProgressBarMedium
        width={progressPerc}
        variant={setVariantProgresBar(state)}
      />
      {/* <SpacingVertical /> */}
      <Text htmlElement='span' variant='small-light'>
        {intl.formatNumber(progress)}
      </Text>{' '}
      <Text htmlElement='span' variant='small-light'>
        {intl.formatMessage({
          id: 'Load.Pager.Of'
        })}
      </Text>{' '}
      <StyledTextTotal htmlElement='span' variant='bold-light'>
        {intl.formatNumber(total)}
      </StyledTextTotal>{' '}
      <Text htmlElement='span' variant='small-light'>
        {intl
          .formatMessage({
            id: 'Load.MailupCommon.Recipients'
          })
          .toLowerCase()}
      </Text>
    </>
  )
}

export default ProgressBar

ProgressBar.propTypes = {
  progressPerc: PropTypes.number,
  state: PropTypes.string,
  progress: PropTypes.number,
  total: PropTypes.number
}

const StyledProgressBarMedium = styled(ProgressBarMedium)`
  p {
    width: 20px;
  }
`

const StyledTextTotal = styled(Text)`
  font-size: 14px !important;
`
